var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.5C5 3.67157 5.67157 3 6.5 3H28C28.3788 3 28.725 3.214 28.8944 3.55279C29.0638 3.89157 29.0273 4.29698 28.8 4.6L23.25 12L28.8 19.4C29.0273 19.703 29.0638 20.1084 28.8944 20.4472C28.725 20.786 28.3788 21 28 21H7V28C7 28.5523 6.55228 29 6 29C5.44772 29 5 28.5523 5 28V4.5ZM7 19H26L21.2 12.6C20.9333 12.2444 20.9333 11.7556 21.2 11.4L26 5H7V19Z",
    fill: "#131542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/Goal.cd855cfd65494beb8286eb7345f8e442.svg";
export { ForwardRef as ReactComponent };